import React, {useContext, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {useSelector} from "react-redux";
import Utils from "../../../helpers/Utils";
import {HistoryProvider} from "../../../App";
import TrialPackageUpdateModal from "../../trialPackageUpdate/TrialPackageUpdateModal";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#e3f2fd',
        borderRadius: theme.shape.borderRadius,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        width: '50%'
    },
    line1: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    line2: {
      display: 'flex',
      width: '100%'
    },
    textFreeTrial: {
        textAlign: "center",
        fontSize: "19px",
        marginBottom: "10px",
        border: "1px solid",
        padding: "2px 6px",
        backgroundColor: "red",
        color: "white",
        borderRadius: "4px",
        display: 'flex',
        alignItems: 'center',
        gap: '8px',

        '& .MuiSvgIcon-root': {
            fontSize: '20px'
        }
    },
    textA2p: {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
        fontSize: '13px'
    },
    buttonContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'flex-end',
        width: '100%'
    },
    upgradeButton: {
        backgroundColor: "#3e50f7",
        color: "#fff",
        textTransform: "capitalize",
        "&:focus, &:hover":{
            backgroundColor: "#3e50f7",
        }
    },
    cancelButton: {
        backgroundColor: "#fff",
        color: "#d32f2f",
        borderColor: "#d32f2f",
        textTransform: "capitalize",
        "&:focus, &:hover":{
            backgroundColor: "#fff",
        }
    },
    textTrialEnds: {
        color: theme.palette.text.primary,
        fontWeight: 'bold',
    },
}));

const TrialNotification = () => {
    const history = useContext(HistoryProvider);
    const { userPackage } = useSelector((state) => (state.billingReducer));
    const classes = useStyles();
    const [isPlanUpdateModalOpen, setIsPlanUpdateModalOpen] = useState(false);

    return (
        <div className={classes.root}>
            <div className={classes.line1}>
                <Typography variant="body1" className={classes.textFreeTrial}>
                    <ErrorOutlineIcon/> You are currently on a free trial!
                </Typography>
                <Typography variant="body1" className={classes.textTrialEnds}>
                    Trial ends {Utils.formatDate(userPackage?.expire_date, 'MM/DD/YYYY')}
                </Typography>
            </div>
            <div className={classes.line2}>
                <Typography variant="body1" className={classes.textA2p}>
                    During your free trial you are unable to register your phone numbers for A2P/10DLC.
                    <br/>
                    Your access to certain features may also be limited.
                    <br/>
                    To upgrade or cancel your account select an option below.
                </Typography>
            </div>
            <div className={classes.buttonContainer}>
                <Button variant="contained" className={classes.upgradeButton} onClick={()=>{ setIsPlanUpdateModalOpen(true); }}>
                    Upgrade subscription
                </Button>
                <Button variant="outlined" className={classes.cancelButton} onClick={()=>{ history.push("/cancellation-request"); }}>
                    Cancel subscription
                </Button>
            </div>

            {
                isPlanUpdateModalOpen &&
                <TrialPackageUpdateModal
                    onClose={()=>{setIsPlanUpdateModalOpen(false);}}
                    isOpen={isPlanUpdateModalOpen}
                />
            }
        </div>
    );
};

export default TrialNotification;